import { Add } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import {
  useCustomMutation,
  useInvalidate,
  useModal,
  useTranslate,
} from "@refinedev/core";
import { useState } from "react";
import { CategorySelect } from "./CategorySelect";
import { Category } from "./RestrictedCategories";
import LoadingButton from "@mui/lab/LoadingButton";
import { useMarketplaceStore } from "../../../../../store/useMarketplaceStore";

type AddCategoryButtonProps = {
  categories: Category[];
};

export const AddCategoryButton = ({ categories }: AddCategoryButtonProps) => {
  const translate = useTranslate();
  const selectedCountry = useMarketplaceStore((state) => state.selectedCountry);
  const invalidate = useInvalidate();

  const { show, close, visible } = useModal();

  const [selectedCategory, setSelectedCategory] = useState<string[]>([]);

  const { mutate, isLoading } = useCustomMutation();

  const onSubmit = (selectedCategory: string[] | null) => {
    if (selectedCategory) {
      mutate(
        {
          url: `store/${selectedCountry?.id}/restrictions/category`,
          method: "post",
          values: { keywords: selectedCategory },
        },
        {
          onSuccess: () => {
            invalidate({
              resource: "all",
              invalidates: ["all"],
            });
            close();
          },
        },
      );
    }
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        sx={{ width: "100px" }}
        startIcon={<Add />}
        onClick={show}
      >
        {translate("buttons.add")}
      </Button>

      <Dialog
        open={visible}
        onClose={isLoading ? undefined : close}
        sx={{ maxHeight: "80vh" }}
      >
        <DialogTitle>
          {translate(
            "pages.storeSecurity.restrictions.restrictedCategories.addDialog.title",
          )}
        </DialogTitle>
        <DialogContent>
          <CategorySelect
            categories={categories}
            onSelectionChange={setSelectedCategory}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={close} disabled={isLoading}>
            {translate("buttons.cancel")}
          </Button>
          <LoadingButton
            loading={isLoading}
            disabled={selectedCategory.length === 0}
            onClick={() => onSubmit(selectedCategory)}
          >
            {translate("buttons.save")}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
